import { render, staticRenderFns } from "./GCUSummary.vue?vue&type=template&id=8a68199e&"
import script from "./GCUSummary.vue?vue&type=script&lang=js&"
export * from "./GCUSummary.vue?vue&type=script&lang=js&"
import style0 from "./GCUSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports